import { auth } from '@/firebase.js';
import router from '@/router';
export default({
  state:{
    email: '',
    password: '',
    error:{
      code: '',
      message: ''
    },
    message: 'Brawo, udało ci się zalogować i za chwile zostaniesz przekierowany do panelu administracyjnego!',
    user: {
      email: '',
      uid: '',
      loggedIn: false
    },
  },
  mutations:{
    setEmail(state, email){
      state.email = email;
    },
    setPassword(state, password){
      state.password = password;
    },
    setUser(state, payload){
      let email = payload.email;
      let uid = payload.uid;
      let loggedIn = payload.loggedIn;
      state.user.email = email;
      state.user.uid = uid;
      state.user.loggedIn = loggedIn;
    },
    signIn(state){
      auth.signInWithEmailAndPassword(state.email, state.password)
      .then(user=>{
        state.user.email = user.user.email;
        state.user.uid = user.user.uid;
        state.user.loggedIn = true;
        setTimeout(()=>{
          router.replace('/admin')
        }, 2000)
      })
      .catch(function(error) {
        state.error.code = error.code;
        state.error.message = error.message;
      });
    },
    signOut(state){
      auth.signOut().then(()=>{
        state.user.email = '';
        state.user.uid = '';
        state.user.loggedIn = false;
        router.replace('/')
      })
      .catch(error=>{
        alert(error)
      })
    },

  },
  actions:{
    checkState({state}){
      auth.onAuthStateChanged((user) => {
        if (user) {
          if (user.user) {
            user = user.user;
          }
          state.user.email = user.email;
          state.user.uid = user.uid;
          state.user.loggedIn = true;   
         } 
      });
    }
  },
  getters:{
    isLoggedIn(state){
      return state.user.loggedIn;
    }
  }
})